<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import PageLayout from 'dashboard/components-next/assistant/PageLayout.vue';
import AgentPlayground from 'dashboard/components-next/assistant/AgentPlayground.vue';

const route = useRoute();
const store = useStore();
const agentId = computed(() => Number(route.params.agentId));

onMounted(() => {
  store.dispatch('assistantAgents/get');
});
</script>

<template>
  <PageLayout
    show-agent-switcher
    :header-title="$t('ASSISTANT.PLAYGROUND.HEADER')"
    :description="$t('ASSISTANT.PLAYGROUND.DESCRIPTION')"
    :show-pagination-footer="false"
    class="h-full"
  >
    <template #body>
      <div class="flex flex-col h-full">
        <AgentPlayground :agent-id="agentId" class="bg-n-solid-1" />
      </div>
    </template>
  </PageLayout>
</template>
